import { withInstall } from '@vuesax-plus/utils'
import SidebarItem from './src/sidebar-item.vue'

export const VsSidebarItem = withInstall(SidebarItem)
export default VsSidebarItem

export * from './src/sidebar-item'
